import { FilledButton } from "@/components/ui/buttons";
import { IonSpinner } from "@ionic/react";
import { memo } from "react";

interface MyPlanErrorStateProps {
  /** Raw error message; falls back to a friendly default when empty. */
  message?: string;
  /**
   * Onboarding status. ONLY `false` (positively known not-onboarded) offers the
   * onboarding entry. `true` / `undefined` (unknown / still loading) fall back to
   * the non-destructive retry — so a completed or unknown-status user can never
   * trigger a plan-regenerating onboarding restart from here.
   */
  isOnboardingCompleted: boolean | undefined;
  onRetry: () => void;
  isRetrying?: boolean;
  onFinishOnboarding: () => void;
}

export const MyPlanErrorState = memo(function MyPlanErrorState({
  message,
  isOnboardingCompleted,
  onRetry,
  isRetrying = false,
  onFinishOnboarding,
}: MyPlanErrorStateProps) {
  const notOnboarded = isOnboardingCompleted === false;

  return (
    <>
      <span className="text-sm text-gray-500">
        {notOnboarded
          ? "Finish setting up your profile to create your plan."
          : (message ?? "We couldn't load your plan.")}
      </span>
      {notOnboarded ? (
        <FilledButton color="black" onClick={onFinishOnboarding} className="w-fit px-4">
          Finish onboarding
        </FilledButton>
      ) : (
        <FilledButton color="black" onClick={onRetry} disabled={isRetrying} className="w-fit px-4">
          {isRetrying ? (
            <span className="flex items-center gap-2">
              <IonSpinner name="crescent" className="h-4 w-4" />
              Trying...
            </span>
          ) : (
            "Try again"
          )}
        </FilledButton>
      )}
    </>
  );
});
